export const unusedNonce = 0;
export const unusedArbiterFee = 0n;
/**
 * Runtime value for the Solana Platform
 */
export const _platform = 'Solana';
//# sourceMappingURL=types.js.map